// material-ui
import { createTheme } from "@mui/material/styles";

// third-party
import { presetPalettes } from "@ant-design/colors";

// project import
import ThemeOption from "./theme";

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  const colors = presetPalettes;

  let greyPrimary = [
    "#ffffff",
    "#fafafa",
    "#f5f5f5",
    "#f0f0f0",
    "#d9d9d9",
    "#bfbfbf",
    "#8c8c8c",
    "#595959",
    "#262626",
    "#141414",
    "#000000",
  ];
  let greyAscent = ["#fafafa", "#bfbfbf", "#434343", "#1f1f1f"];
  let greyConstant = ["#fafafb", "#e6ebf1"];

  colors.grey = [...greyPrimary, ...greyAscent, ...greyConstant];

  const paletteColor = ThemeOption(colors, presetColor, mode);

  return createTheme({
    palette: {
      mode,
      common: {
        black: "#000",
        white: "#fff",
        iconColor: "#101828",
        border: "#DBDEE0",
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],
        secondary: "#344054",
        disabled: paletteColor.grey[400],
        warning: "#E62E05",
        admin: "#F63D68",
        pilot: "#1570EF",
        error: "#ff4d4f",
      },
      action: {
        disabled: paletteColor.grey[300],
      },
      status: {
        active: {
          background: "#ECFDF3",
          color: "#027A48",
          icon: "#12B76A",
        },
        inactive: {
          background: "#FEF3F2",
          color: "#B42318",
          icon: "#F04438",
        },
        never_onboarded: {
          background: "#EEF4FF",
          color: "#3538CD",
          icon: "#6172F3",
        },
        role: {
          background: "#F2F4F7",
          color: "#344054",
          icon: "#6172F3",
        },
      },
      divider: "#DBDDE0",
      background: {
        paper: paletteColor.grey[0],
        grey: colors.grey,
        default: "#F4F4F5",
      },
      error: {
        ...paletteColor.error,
        main: "#EF4141",
      },
      primary: {
        ...paletteColor.primary,
        main: "#101828",
      },

      // error: {
      //   contrastText: "#fff",
      //   dark: "#BC1B06",
      //   darker: "#5c0011",
      //   light: "#ffa39e",
      //   lighter: "#fff1f0",
      //   main: "#FDA29B",
      // },
      blue: {
        100: "#DAECFF",
        200: "#80BFFF",
        400: "#3399FF",
        500: "#007FFF",
        600: "#0072E5",
        700: "#0059B2",
      },
      border: {
        input: "#DBDEE0",
      },
    },
  });
}
